import React, { useState } from 'react';

const LogoSelection = ({ leaderboardImageOptions, setChosenLeaderboardImage, isUserInMasterPool }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  // If leaderboardImageOptions doesn't exist or user is in master pool, don't render
  if (!leaderboardImageOptions || isUserInMasterPool) {
    return null;
  }

  const handleSelect = (option) => {
    setSelectedOption(option);
    setChosenLeaderboardImage(option.logo);
    setIsOpen(false);
  };

  return (
    <div className="flex flex-col items-center mb-4">
      {/* Original text display */}
      <div className="mb-2 text-center">
        {leaderboardImageOptions?.text}
      </div>
      
      {/* Custom dropdown */}
      <div className="relative w-64">
        <button
          type="button"
          className="w-full py-2 px-4 bg-white border border-gray-300 rounded-md shadow-sm text-left cursor-default focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{selectedOption ? selectedOption.name : leaderboardImageOptions.dropdownText}</span>
          <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </span>
        </button>

        {isOpen && (
          <div className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto">
            {leaderboardImageOptions.options.map((option) => (
              <div
                key={option.name}
                className="cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-gray-100"
                onClick={() => handleSelect(option)}
              >
                {option.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoSelection;